'use client'
import { FreeMode } from 'swiper/modules'

import { Parkinglot } from '@/components/detail/components/shared/parkinglotInfo/model'
import ParkinglotCard from '@/components/recommendParkinglot/components/card/view'

import type { SliderOptions } from '@/shared/components/slider/types/sliderOptions'
import SliderView from '@/shared/components/slider/view'
import { Text } from '@/shared/components/typography'

interface RecommendViewProps {
  sortedParkinglots: Parkinglot[]
}

const RecommendParkinglotView = ({ sortedParkinglots }: RecommendViewProps) => {
  const sliderOptions: SliderOptions = {
    fullScreen: false,
    isFreeMode: true,
    swiperModules: [FreeMode]
  }

  return (
    <section className="section flex flex-col gap-4 pt-[0px]">
      <div className="ml-4">
        <Text level="text3" weight="bold" color="text090">
          이 주변 주차장은 어떠세요?
        </Text>
      </div>

      <SliderView items={sortedParkinglots} options={sliderOptions} slideComponent={ParkinglotCard} />
    </section>
  )
}

export default RecommendParkinglotView
